NS("UI.Util")

/**
 * @class
 */
UI.Util.FullScreen = Static( /** @lends UI.Util.FullScreen */ {
    isSupported () {
        return document.fullscreenEnabled ||
               document.webkitFullscreenEnabled ||
               document.mozFullScreenEnabled ||
               document.msFullscreenEnabled
    },

    isFullScreen () {
        return !!this.fullScreenElement()
    },

    fullScreenElement () {
        // IE 11 doesn't have similar boolean property, so check whether
        // document.msFullscreenElement is null instead.
        return document.fullscreenElement ||
               document.webkitFullscreenElement ||
               document.mozFullScreenElement ||
               document.msFullscreenElement
    },

    exitFullscreen () {
        const  doc = document

        if (doc.webkitCancelFullScreen) {
            doc.webkitCancelFullScreen()
        } else if (doc.mozCancelFullScreen) {
            doc.mozCancelFullScreen()
        } else if (doc.msExitFullscreen) {
            doc.msExitFullscreen()
        } else if (doc.exitFullscreen) {
            doc.exitFullscreen()
        }
    },

    requestFullScreenWithKeys (element) {
        if (element.mozRequestFullScreenWithKeys) {
            element.mozRequestFullScreenWithKeys()
        } else if (element.webkitRequestFullscreen) {
            element.webkitRequestFullscreen()
        } else {
            this.requestFullScreen(element)
        }
    },

    requestFullScreen (element) {
        if (element.webkitRequestFullscreen) {
            element.webkitRequestFullscreen()
        } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen()
        } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen()
        } else if (element.requestFullscreen) {
            element.requestFullscreen()
        }
    }
})
